import statisticItem from '@/components/atoms/statistic-item/index.vue'
import {mapGetters} from 'vuex';

export default {
    name: 'course-statistic',
    components: {
        statisticItem
    },
    computed: {
        ...mapGetters({
            currentItem: 'courses/currentItem',
        })
    },
    methods: {
        getCurrentStatisticData(key) {
            if (this.currentItem.userCourse.data.hasOwnProperty('completedMaterials')) {
                return this.currentItem.userCourse.data[key]
            }
            return 0;
        },
        calculateStatisticPercent(total, current) {
            if (this.currentItem.userCourse.data.hasOwnProperty('completedMaterials')) {
                if (!this.currentItem[total]) return 0;
                return Math.round((100 / this.currentItem[total]) * this.currentItem.userCourse.data[current])
            }
            return 0;
        }
    }
}
